import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

export interface RemoveFromFavouritesResponse extends AxiosResponse {
  data: {
    errorCode: number
    errorMessage: string
    apiStatus: string
    message: string
    data: string
  }
}

interface RemoveFromFavouritesRequest {
  favoriteId: string
  favourite: boolean
  propertyId: string
}

export interface RemoveFromFavlistRequest extends Partial<AxiosRequestConfig> {
  params: RemoveFromFavouritesRequest
}

export function removePropertyFromFavoriteListApi(
  {
    params,
    method = "put",
    url = `/user/property/${params.propertyId}/favourite/${
      params.favourite ? "true" : "false"
    }/favouriteId/${params.favoriteId}`,
    ...config
  }: RemoveFromFavlistRequest,
  axiosInstance: AxiosInstance,
): Promise<RemoveFromFavouritesResponse> {
  return axiosInstance({
    method,
    url,
    ...config,
  }) as Promise<RemoveFromFavouritesResponse>
}
